import type { CellDataType } from '@blocksuite/affine/model';
import {
  databaseLineageColumns,
  projectDatabaseRowCells,
  storedDatabaseCellValue,
} from '@streamlain/database-identity';

import type { SerializedCells } from './types';

/**
 * The cells the readers of a database block see, read once where its rows
 * are loaded: a column whose type changed reads its stored cells through its
 * lineage and holds the converted cell under its id, so every reader keeps
 * reading a cell by column id. Rows are copied; the loaded cells stay as
 * stored.
 */
export function readerDatabaseCells(
  columns: readonly unknown[],
  cells: SerializedCells
): SerializedCells {
  const lineageColumns = databaseLineageColumns(columns);
  if (!lineageColumns.length) return cells;
  const view: SerializedCells = {};
  for (const [rowId, row] of Object.entries(cells)) {
    view[rowId] = projectDatabaseRowCells(
      lineageColumns,
      { ...row },
      storedDatabaseCellValue,
      (columnId, value) => ({ columnId, value }) as CellDataType
    );
  }
  return view;
}
